<template>
  <div>
    <b-form-group v-if="showDocAndName">
      <b-form-input
        required
        :title="labels.doc"
        v-model="form.doc"
        name="doc"
        id="doc"
        masked="true"
        v-mask="['###.###.###-##', '##.###.###/####-##']"
        :state="validateField('doc')"
      />
      <label
        for="doc"
        class="custom-input-label"
        v-if="validateDOC(form.doc) !== false"
        >{{ labels.doc }}</label
      >
      <label
        for="doc"
        class="custom-input-label"
        v-if="validateDOC(form.doc) === false"
        >{{ labels.invalidDoc }}</label
      >
    </b-form-group>

    <b-form-group v-if="showDocAndName">
      <b-form-input
        required
        :title="labels.name"
        v-model="form.name"
        name="name"
        id="name"
        :state="validateField('name')"
      />
      <label for="name" class="custom-input-label">{{ labels.name }}</label>
    </b-form-group>

    <b-form-group>
      <b-form-input
        required
        :title="labels.cardName"
        v-model="form.cardName"
        name="cardName"
        id="cardName"
        :state="validateField('cardName')"
      />
      <label for="cardName" class="custom-input-label">{{
        labels.cardName
      }}</label>
    </b-form-group>

    <b-row>
      <b-col class="col-12 col-md-6">
        <b-form-group>
          <b-form-input
            required
            :title="labels.cardNumber"
            v-model="form.cardNumber"
            class="fix-padding"
            masked="true"
            v-mask="'#### #### #### ####'"
            name="cardNumber"
            id="cardNumber"
            :state="validateField('cardNumber')"
          />
          <label
            for="cardNumber"
            class="custom-input-label"
            v-if="validateCardNumber(form.cardNumber) !== false"
            >{{ labels.cardNumber }}</label
          >
          <label
            for="cardNumber"
            class="custom-input-label"
            v-if="validateCardNumber(form.cardNumber) === false"
            >{{ labels.invalidNumber }}</label
          >
        </b-form-group>
      </b-col>

      <b-col class="col-6 col-md-3 pr-1 pl-md-1">
        <b-form-group>
          <b-form-input
            required
            :title="labels.cardValidate"
            v-model="form.cardValidate"
            class="fix-padding"
            masked="true"
            v-mask="'##/##'"
            name="cardValidate"
            id="cardValidate"
            :state="validateField('cardValidate')"
          />
          <label
            for="cardValidate"
            class="custom-input-label"
            v-if="validateExpiration(form.cardValidate) !== false"
            >{{ labels.cardValidate }}</label
          >
          <label
            for="cardValidate"
            class="custom-input-label"
            v-if="validateExpiration(form.cardValidate) === false"
            >{{ labels.invalidExpiration }}</label
          >
        </b-form-group>
      </b-col>

      <b-col class="col-6 col-md-3">
        <b-form-group>
          <b-form-input
            required
            :title="labels.cvv"
            v-model="form.cvv"
            class="fix-padding"
            masked="true"
            v-mask="'###'"
            name="cvv"
            id="cvv"
            :state="validateField('cvv')"
          />
          <label
            for="cvv"
            class="custom-input-label"
            v-if="validateCVV(form.cvv, form.cardNumber) !== false"
            >{{ labels.cvv }}</label
          >
          <label
            for="cvv"
            class="custom-input-label"
            v-if="validateCVV(form.cvv, form.cardNumber) === false"
            >{{ labels.invalidCVV }}</label
          >
        </b-form-group>
      </b-col>
    </b-row>

    <!-- <b-form-group>
      <b-select required :title="labels.split" v-model="form.split" name="split" id="split">
        <option v-for="key in [1,2,3,4,5,6,7,8,9,10,11,12]" :key="key" :value="key" :selected="key === form.split">{{key}} x</option>
      </b-select>
      <label for="split" class="custom-input-label">{{labels.split}}</label>
    </b-form-group> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mask } from 'vue-the-mask'
import { isCPForCNPJ } from '@/helpers/validateDoc'
import {
  validateCardNumber,
  validateExpiration,
  validateCVV,
} from '@/service/iugu'

const props = {
  form: {
    type: Object,
    require: true,
  },
  validate: {
    type: Boolean,
    default: false,
  },
  showDocAndName: {
    type: Boolean,
    default: true,
  },
}

export default {
  props,
  directives: { mask },
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),

    labels: function() {
      return Object.assign(
        {},
        this.resources.page.home.iugoCardForm,
        this.resources.page.home.iugoCardForm.errorMessages
      )
    },

    isValid: function() {
      return (
        this.validateDOC(this.form.doc) &&
        this.validateField('cardName') &&
        this.validateCardNumber(this.form.cardNumber) &&
        this.validateExpiration(this.form.cardValidate) &&
        this.validateCVV(this.form.cvv, this.form.cardNumber)
      )
    },
  },
  methods: {
    validateDOC(value) {
      if (!this.showDocAndName) return true

      const customValidate = value => {
        return parseFloat(value.toString().replace(/(\.|-)/g, '')) !== 0
      }

      let isValid = !value ? undefined : isCPForCNPJ(value)
      isValid = isValid ? customValidate(value) : isValid
      return isValid
    },

    validateCardNumber(value) {
      return !value ? undefined : validateCardNumber(value)
    },

    validateExpiration(value) {
      return !value ? undefined : validateExpiration(value)
    },

    validateCVV(cvv) {
      const number = this.form.cardNumber
      return !(cvv && number) ? undefined : validateCVV(cvv, number)
    },

    validateField(field) {
      const validationByField = {
        doc: this.validateDOC,
        cardNumber: validateCardNumber,
        cardValidate: validateExpiration,
        cvv: this.validateCVV,
        cardName: value => value.trim().split(' ').length > 1,
      }

      const value = this.form[field]
      const validate = validationByField[field]

      if (!this.validate && !value.length) return undefined

      if (!value.length) return false

      return validate ? validate(value) : true
    },
  },
}
</script>

<style lang="scss">
@import '~@/styles/custom/colors';

.custom-input-label.text-red02 {
  color: map-get($theme-colors, 'red02');
}
.fix-padding {
  padding: 0.375rem 0.75rem !important;
}
</style>
